import { useEffect, useState } from 'react';
import { listSpaces, type SpaceListItem } from '../api/auth';
import { SpacesLanding } from '../spaces/SpacesLanding';

// Authenticated but no active Space (reached on a neutral host like login.* when
// the session has no active Space). Never silently fall back to a different Space:
//   - exactly one accessible Space (with a subdomain) → go there (preselect),
//   - more than one → let the user pick (no guessing),
//   - none → neutral message.
export function NoActiveSpace({
  baseHost,
  portSuffix,
  protocol,
}: {
  baseHost: string;
  portSuffix: string;
  protocol: string;
}) {
  const [spaces, setSpaces] = useState<SpaceListItem[] | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    listSpaces()
      .then((rows) => {
        if (!cancelled) setSpaces(rows.filter((s) => s.subdomain && s.status === 'active'));
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const hostFor = (s: SpaceListItem) => `${protocol}//${s.subdomain}.${baseHost}${portSuffix}/`;

  useEffect(() => {
    const only = spaces && spaces.length === 1 ? spaces[0] : undefined;
    if (only && baseHost) {
      window.location.assign(hostFor(only));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [spaces, baseHost, portSuffix, protocol]);

  if (failed) {
    return (
      <main className="loading-screen">
        <h1>Chyba</h1>
        <p>Nepodařilo se načíst seznam Spaces. Zkus to prosím znovu.</p>
      </main>
    );
  }
  if (!spaces) {
    return (
      <main className="loading-screen">
        <p>Načítání…</p>
      </main>
    );
  }
  if (spaces.length === 0) {
    return (
      <main className="loading-screen">
        <h1>Žádná dostupná Space</h1>
        <p>Tvůj účet nemá přístup k žádné Space. Kontaktuj prosím správce.</p>
      </main>
    );
  }
  if (spaces.length === 1) {
    return (
      <main className="loading-screen">
        <p>Přesměrování…</p>
      </main>
    );
  }
  return <SpacesLanding initialSpaces={spaces} />;
}
